import React, { useEffect, useState } from 'react';
import AUX from '../../../hoc/Aux_';
import { FaClock } from 'react-icons/fa';
import { Button } from 'reactstrap';
import moment from 'moment';
import {
  getEmpTimesheet,
  getEmpTimesheetMember,
  getEmpTimesheetProject,
} from '../../../redux/MainAction';
import { useDispatch, useSelector } from 'react-redux';
import AddTimeEmployee from './AddTimeEmployee';
import { toast } from 'react-toastify';

const EmployeeTimesheet = () => {
  const dispatch = useDispatch();
  const ownId = localStorage.getItem('ownerId');
  const userID = localStorage.getItem('userId');
  const member = useSelector((state) => state?.Webtracker?.empTimeMembers);
  const prj = useSelector((state) => state?.Webtracker?.empTimePrject);
  const timesheet = useSelector((state) => state?.Webtracker?.empTimesheet);

  const [isModalOpen, setIsModalOpen] = useState(false);
  const date = new Date();
  const tomorrow = new Date();
  tomorrow.setDate(date.getDate() - 1);

  const toggleModal = () => {
    setIsModalOpen(!isModalOpen);
  };

  const [filters, setFilters] = useState({
    projectId: '',
    startDate: moment(tomorrow).format('YYYY-MM-DD'),
    endDate: moment(date).format('YYYY-MM-DD'),
  });

  useEffect(() => {
    getList();
  }, []);

  const getList = () => {
    const empPay = {
      ownerId: ownId, // required
      startDate: filters?.startDate, // required
      endDate: filters?.endDate, // required
    };
    dispatch(getEmpTimesheet(empPay));
    const data = {
      offset: 0,
      limit: 100,
      ownerId: ownId,
    };
    dispatch(getEmpTimesheetMember(data));
    dispatch(getEmpTimesheetProject(data));
  };

  const onChangeFilter = (e) => {
    const { name, value } = e.target;
    setFilters({ ...filters, [name]: value });
  };
  const convertSeconds = (seconds) => {
    const hours = Math.floor(seconds / 3600);
    const minutes = Math.floor((seconds % 3600) / 60);
    return `${hours}h : ${minutes}m`;
  };
  const [showReset, setShowReset] = useState(false);

  console.log('timesheet', timesheet);

  const handleApply = (e) => {
    e.preventDefault();
    if (filters?.startDate && filters?.endDate) {
      const startDate = moment(filters.startDate);
      const endDate = moment(filters.endDate);

      if (startDate.isAfter(endDate)) {
        toast.error('Start date cannot be greater than End date', {
          position: 'top-right',
        });
        return;
      }
    }

    const payload = { ownerId: ownId };

    if (filters?.startDate) {
      payload.startDate = filters.startDate;
    }
    if (filters?.startDate) {
      payload.endDate = filters.endDate;
    }

    if (filters?.projectId) {
      payload.projectId = filters.projectId;
    }
    dispatch(getEmpTimesheet(payload));
    setShowReset(true);
  };
  const handleReset = (e) => {
    e.preventDefault();
    const data = {
      ownerId: ownId,
      startDate: moment(tomorrow).format('YYYY-MM-DD'),
      endDate: moment(date).format('YYYY-MM-DD'),
    };
    dispatch(getEmpTimesheet(data));
    setShowReset(false);
    setFilters({
      ownerId: ownId,
      projectId: '',
      startDate: moment(tomorrow).format('YYYY-MM-DD'),
      endDate: moment(date).format('YYYY-MM-DD'),
    });
  };
  return (
    <AUX>
      <div className="page-content-wrapper">
        <div className="col-12 d-flex align-items-center mb-2">
          <h5 className="text-muted col-4"></h5>
          <AddTimeEmployee open={isModalOpen} onClose={toggleModal} />
          <div className="col-8 d-flex justify-content-end align-items-center">
            {/* <Button
              color="success"
              size="sm"
              className="mr-2 d-flex align-items-center"
              onClick={() => downloadCSV(csv, 'Attendance Report')}
            >
              <FaFileCsv className="mr-1" /> CSV
            </Button>
            <Button
              color="primary"
              size="sm"
              className="mr-2 d-flex align-items-center"
              onClick={() => downloadXLS(xlsx, 'Attendance Report')}
            >
              <FaFileExcel className="mr-1" /> XLSX
            </Button> */}

            <Button
              className="d-flex align-items-center"
              size="sm"
              color="primary"
              onClick={toggleModal}
            >
              <FaClock className="mr-1" /> Add Time
            </Button>
          </div>
        </div>
        <div className="container-fluid">
          <div className="row">
            <div className="col-12">
              <div className="card m-b-20">
                <div className="d-flex justify-content-between align-items-center m-2">
                  <div className="d-flex justify-content-start align-items-center">
                    <select
                      className="form-control font-14"
                      name="employeeId"
                      value={userID}
                      disabled
                      onChange={onChangeFilter}
                    >
                      {/* <option value=''>Select Member</option> */}
                      {member?.rows?.map((mems, idx) => (
                        <option key={idx} value={mems?.id}>
                          {mems?.user?.firstName} {mems?.user?.lastName}
                        </option>
                      ))}
                    </select>
                    <select
                      className="form-control font-14 ml-1"
                      name="projectId"
                      value={filters?.projectId}
                      onChange={onChangeFilter}
                    >
                      <option value="">Select Project</option>
                      {prj?.rows?.map((mems, idx) => (
                        <option key={idx} value={mems?.id}>
                          {mems?.name}
                        </option>
                      ))}
                    </select>
                    <div
                      className="d-flex align-items-center font-14 ml-2"
                      style={{ gap: '5px' }}
                    >
                      <input
                        type="date"
                        className="form-control font-14"
                        name="startDate"
                        value={filters?.startDate}
                        onChange={onChangeFilter}
                        max={moment().format('YYYY-MM-DD')}
                      />
                      To
                      <input
                        type="date"
                        className="form-control font-14"
                        name="endDate"
                        value={filters?.endDate}
                        onChange={onChangeFilter}
                        max={moment().format('YYYY-MM-DD')}
                      />
                    </div>
                    <Button
                      className="d-flex align-items-center justify-content-center ml-2"
                      style={{ padding: '6px 14px' }}
                      size="sm"
                      color="primary"
                      onClick={handleApply}
                    >
                      <i className="ion-ios7-search font-20"></i>
                    </Button>

                    {showReset ? (
                      <Button
                        className="d-flex align-items-center justify-content-center ml-2"
                        style={{ padding: '6px 13px' }}
                        size="sm"
                        color="danger"
                        onClick={handleReset}
                      >
                        <i className="mdi mdi-close font-20"></i>
                      </Button>
                    ) : (
                      ''
                    )}
                  </div>
                </div>
                <div className="card-body">
                  <table
                    id="datatable"
                    className="table dt-responsive nowrap table-vertical"
                    width="100%"
                    cellSpacing="0"
                  >
                    <thead>
                      <tr>
                        <th>Time</th>
                        <th>Timezone</th>
                        <th>Manually Added</th>
                        <th>Project</th>
                        <th>Task</th>
                        <th>Description</th>
                        <th>Amount</th>
                        <th>Total Time</th>
                      </tr>
                    </thead>
                    <tbody>
                      {timesheet?.activities?.length > 0 ? (
                        timesheet?.activities?.map((day, dateIndex) => (
                          <>
                            {/* Date Row */}
                            <tr key={dateIndex} className="table-date-row">
                              <td colSpan="7">
                                <strong>Date:</strong> {day?.date}
                              </td>
                            </tr>
                            {/* Activities for this date */}
                            {day?.activities?.length > 0 ? (
                              day?.activities?.map(
                                (activity, activityIndex) => (
                                  <tr key={`${dateIndex}-${activityIndex}`}>
                                    <td>
                                      {convertSeconds(activity?.totalTime)}
                                    </td>
                                    <td>{activity?.timezone}</td>
                                    <td>{`${activity?.manuallyAddedPercent}%`}</td>
                                    <td>{activity?.projectName}</td>
                                    <td>{activity?.taskName}</td>
                                    <td>{activity?.description}</td>
                                    <td>{activity?.totalAmount}</td>
                                    <td>
                                      {convertSeconds(activity?.totalTime)}
                                    </td>
                                  </tr>
                                )
                              )
                            ) : (
                              <tr key={`${dateIndex}-no-activities`}>
                                <td colSpan="7" className="text-center">
                                  No activities available for this date.
                                </td>
                              </tr>
                            )}
                          </>
                        ))
                      ) : (
                        <tr key={`no-activities`}>
                          <td colSpan="8" className="text-center">
                            No activities available for this date.
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </AUX>
  );
};

export default EmployeeTimesheet;
